module.exports = __webpack_public_path__ + "static/media/bg.725c45cf.svg";